/*
 *
 * Loading action/reducer
 *
 */

import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { setGlobalUserInfo, setToken } from "scenes/redux";
import { UserInfo } from "types/UserInfo";
import { createActionDispatchers } from "utils/reduxHelpers";

export type State = {
  loading: boolean;
  userInfo: UserInfo;
  token: string;
};

export const initialState: State = {
  loading: false,
  userInfo: {
    sub: "",
    cidpId: "",
    email: "",
    ext: {
      sub_type: "",
      auth_provider: "",
    },
    given_name: "",
    family_name: "",
    preferred_username: "",
  },
  token: "",
};

const slice = createSlice({
  name: "loading",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    afterUserInfoLoaded(state, action: PayloadAction<UserInfo>) {
      state.loading = false;
      state.userInfo = action.payload;
    },
  },
});

/**
 * create actions WITHOUT reducer (pure action) here
 */
export const loadDashboardUserInfo = createAction<string>(
  "loading/loadDashboardUserInfo"
);

/**
 * actions from slice to be exported for saga
 */
export const { afterUserInfoLoaded } = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  ["afterUserInfoLoaded"],
  // pure actions
  {
    loadDashboardUserInfo,
    setToken,
    setGlobalUserInfo,
    goToDashboard: (resource: string) => {
      const query = resource ? `?resource=${resource}` : "";
      return push(`/dashboard${query}`);
    },
  }
);

export default slice.reducer;
